export default __webpack_public_path__ + "static/media/logo-500.ccfbc758.png";